/* USG cart drawer: dynamic "一緒にコーデしたいアイテム" (2026-10 ver2.3) */
(() => {
  if (customElements.get('usg-cart-recs')) return;

  const MAX_ITEMS = 6;
  const cache = new Map();
  let lastHtml = '';

  class UsgCartRecs extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-usg-recs-list]');
      this.productId = this.getAttribute('product-id');
      this.exclude = (this.getAttribute('exclude') || '').split(',').filter(Boolean);
      if (!this.list || !this.productId) return;

      if (cache.has(this.productId)) {
        this.render(cache.get(this.productId));
        return;
      }

      if (lastHtml) this.render(lastHtml, true);

      const base = this.getAttribute('base-url') || '/recommendations/products';
      const url = `${base}?product_id=${encodeURIComponent(this.productId)}&limit=10&section_id=usg-cart-recs&intent=related`;

      fetch(url)
        .then((res) => (res.ok ? res.text() : ''))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const list = doc.querySelector('[data-usg-recs-list]');
          const html = list && list.querySelector('.usg-rec') ? list.innerHTML : '';
          cache.set(this.productId, html);
          if (this.isConnected) this.render(html);
        })
        .catch(() => {
          if (this.isConnected) this.render('');
        });
    }

    render(html, isPlaceholder = false) {
      let content = html;
      if (!content && !isPlaceholder) {
        const fallback = this.querySelector('template[data-usg-fallback]');
        content = fallback ? fallback.innerHTML : '';
      }

      const tmp = document.createElement('div');
      tmp.innerHTML = content;
      tmp.querySelectorAll('.usg-rec[data-product-id]').forEach((el) => {
        if (this.exclude.includes(el.dataset.productId)) el.remove();
      });
      const cards = [...tmp.querySelectorAll('.usg-rec')];
      cards.slice(MAX_ITEMS).forEach((el) => el.remove());

      if (!cards.length) {
        if (!isPlaceholder) this.hidden = true;
        return;
      }

      if (!isPlaceholder && html) lastHtml = html;
      this.list.replaceChildren(...tmp.childNodes);
      this.list.scrollLeft = 0;
      this.hidden = false;
      this.classList.add('is-loaded');
    }
  }

  customElements.define('usg-cart-recs', UsgCartRecs);
})();
